const SET_LIST = (state, payload) => {
  state.list = payload
}

export default {
  SET_LIST
}



// WEBPACK FOOTER //
// ./src/features/payer_payment_notifications/store/mutations.js